import React, { useMemo } from 'react';

import { Header } from '@components/Organisms/Header';
import LanguageSwitcher from '@components/TheHeader/LanguageSwitcher';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { selectorUser } from '@model/User';
import { useTranslation } from 'react-i18next';
import { WelcomeMessage } from '@components/WelcomeMessage/index';
import { ACTION_VARIANTS, Button, ICON_NAMES } from '@reverse-hr/design-system';
import { MODAL_IDS_MAP } from '@app/constants/modals';
import { selectorSetModalId, selectorSetModalOpened } from '@model/index';
import { selectorIsCompensationVisible } from '@model/showcase-table';
import { useLocation, useParams } from 'react-router-dom';
import { jobClientsSelector } from '@model/Job/Job.selectors';
import { JOB_PROGRESS_SWITCH_SEGMENT_ENTITIES } from '@components/navigation/JobProgressSwitch/JobProgressSwitch.types';

const TheHeader = ({
  labels = {
    welcome: 'Bentornato',
    share: 'Condividi',
  },
  onClick,
}) => {
  const user = useStoreState(selectorUser);
  const isCompensationVisible = useStoreState(selectorIsCompensationVisible);
  const setModalOpened = useStoreActions(selectorSetModalOpened);
  const setModalId = useStoreActions(selectorSetModalId);
  const isShowcasePath = useLocation().pathname.includes('/showcase');
  const jobClients = useStoreState(jobClientsSelector);
  const { entityType } = useParams();

  const isShareButtonVisible =
    entityType === JOB_PROGRESS_SWITCH_SEGMENT_ENTITIES.JOBS;

  const hasJobClientsWithoutCompensationVisibility = useMemo(() => {
    return jobClients.some(
      client => client.isCompensationPackageVisible === false,
    );
  }, [jobClients]);

  const handleCompensationButtonClick = async () => {
    setModalOpened(true);
    setModalId(MODAL_IDS_MAP.COMPENSATION_VISIBILITY);
  };

  return (
    <div className="c-app-header">
      <Header
        logo={
          __ENVIRONMENT_CONFIG__.IS_THEME_AKI
            ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/aaron-king-logo.png`
            : `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/reverse-logo.svg`
        }
      >
        <WelcomeMessage />

        <div className="c-app-header__desktop-actions">
          {user.type === 'manager' &&
            hasJobClientsWithoutCompensationVisibility && (
              <Button
                variant={ACTION_VARIANTS.OUTLINE}
                leftIcon={ICON_NAMES.MONITOR}
                onClick={handleCompensationButtonClick}
              >
                {isCompensationVisible
                  ? labels.hide_compensation
                  : labels.show_compensation}
              </Button>
            )}

          {isShareButtonVisible && (
            <Button
              variant={ACTION_VARIANTS.SECONDARY}
              leftIcon={ICON_NAMES.SHARE_OUTLINE}
              onClick={onClick}
            >
              {labels.share}
            </Button>
          )}
        </div>

        <div className="c-app-header__mobile-actions">
          {user.type === 'manager' && isShowcasePath && (
            <Button
              variant={ACTION_VARIANTS.OUTLINE}
              leftIcon={ICON_NAMES.MONITOR}
              onClick={handleCompensationButtonClick}
            />
          )}

          {isShareButtonVisible && (
            <Button
              variant={ACTION_VARIANTS.SECONDARY}
              leftIcon={ICON_NAMES.SHARE_OUTLINE}
              onClick={onClick}
            />
          )}
        </div>

        <LanguageSwitcher />
      </Header>
    </div>
  );
};

export default TheHeader;
